module.exports = __webpack_public_path__ + "img/left_b.223c1069.svg";